// extracted by mini-css-extract-plugin
export default {"replyButton":"Fc7-u","replyIcon":"SWHsP"};